import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux/rootReducer"
import { memoize, arrToMap } from "nodash"
import { selectSelectedLayerIds } from "panels/content/side-panel/slice.new"

const root = (state: RootState) => state.project.data.mapComments

export const selectAllMapComments = (state: RootState) => root(state)

export const selectMapCommentsMap = createSelector([selectAllMapComments], (comments) =>
    arrToMap(comments, "id")
)

export const selectMapCommentById = memoize((id: string) =>
    createSelector([selectMapCommentsMap], (comments) => comments[id]!)
)

export const selectIsMapCommentThreadOpen = createSelector(
    [selectMapCommentsMap, selectSelectedLayerIds],
    (comments, selectedIds) => selectedIds.some((id) => !!comments[id])
)

export const selectCommentPlacementState = (state: RootState) =>
    state["map-comments-ui-v1"].commentPlacingState
